<template>
  <div style="display: inline-block;margin: 0 1.2vw;cursor: pointer" @click="click" >
    <span style="pointer-events: none">
    <span class="material-icons-outlined">{{icon}}</span>
    <span class="label">{{label}}</span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
    },
    label: {
      type: String,
    },
  },
  methods: {
    click() {
      this.$emit('button-click')
    }
  },
  name: "SettingButton"
}
</script>

<style scoped>
.label {
  font-size: 2vh;
  margin-left: -4px;
  pointer-events: none;
}
.material-icons-outlined {
  vertical-align: middle;
  display: inline;
  font-family: 'Material Icons';
  font-size: 3.5vh;
  line-height: 1;

  pointer-events: none;
  color: #e9671f;
  /*height: 6vh;*/
  /*line-height: 6vh;*/
}
</style>



// WEBPACK FOOTER //
// src/components/SettingButton.vue